import type { ReactNode } from 'react';

interface ICardBodyProps {
    children: ReactNode;
}

export function CardBody(props: ICardBodyProps) {
    return <div className="card__body">{props.children}</div>;
}
